import {
    Add,
    ArrowBackIos,
    Remove,
} from "@mui/icons-material";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    IconButton,
    Typography,
    useTheme,
} from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import DataVisualization from "pages/c-dad-datavisualization";
import MapVisualization from "pages/c-dad-mapVisualization";
import SummaryStatisticsDataVisualization from "pages/c-dad-summary-statistics";
import DataPrep from "pages/data-fill";
import DataFillToolTip from "pages/data-fill/components/dataFillToolTipComponent";
import RawData from "pages/raw-data";
import SignalDataStatistics from "pages/signal-data-stats";
import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getListFromRawData, isJsonString } from "utility/helper";
import { FillToolTipContent } from "./components/FillDataToolTip";

dayjs.extend(utc);

export interface JobDetail {
    id: number;
    title: string;
    value: string;
}


const UserData = () => {
    const routeLocation = useLocation();
    const theme = useTheme();
    const { state: {userInput, jobName, id, cDadUnNestedDataValue, pageNo, defaultTab, subJobs, headerJobId} } = routeLocation;
    console.log('cDadUnNestedDataValue', cDadUnNestedDataValue)
    const navigate = useNavigate();
    const [expanded, setExpanded] = useState<string>(defaultTab ? defaultTab :'panel1');

    const handleChange = (panel: any) =>  {
        setExpanded(panel === expanded ? '' : panel);
    };
    const handleBackClick = () => {
        navigate("/c-dad");
    }

    let currentUserInputData: Array<string> = [];
    let userInputData: any = userInput.replaceAll("'", '"');
    let userInputVinList: string[] = [];
    if (isJsonString(userInputData)) {
        userInputData = JSON.parse(userInputData)
        userInputData?.forEach((item: any) => {
            if ((item.title === "list_CanLabels" || item.title === "list_51FLabels") && item?.value !== null) {
                if(item?.value) {
                    currentUserInputData.push(...item.value)
                }
            }
            if(item?.title === 'vins') {
                userInputVinList = item?.value
            }
        });
        currentUserInputData = currentUserInputData.filter((item: string) => item !== 'TripCount')
    }
    const jobDetails: JobDetail[] = [
        {
            id: 1,
            title: "Job Name",
            value: jobName,
        },
        {
            id: 2,
            title: "Job Id",
            value: id,
        },
    ];
    console.log('usesrs', userInputVinList, getListFromRawData(cDadUnNestedDataValue.data.data, 'vin'))
    const vinListTimeSeries = userInputVinList?.length > 0 ? userInputVinList : getListFromRawData(cDadUnNestedDataValue.data.data, 'vin');
    const signalListUnnested = cDadUnNestedDataValue?.data.unnested_signals || currentUserInputData;
    
      const requestTimeListTimeSeries = getListFromRawData(cDadUnNestedDataValue.data.data, 'gpsDateTime');
    return (
        <div id='dataPrep'>
            <IconButton
                onClick={handleBackClick}
                edge="end"
            ><ArrowBackIos style={{ color: theme.palette.primary.contrastText }} />
                <Typography
                    fontWeight='bold'
                    variant="h6"
                    color={theme.palette.primary.contrastText}
                >
                    {"Back"}
                </Typography></IconButton>
            <Accordion
                expanded={expanded === "panel1"}
                onChange={() => handleChange("panel1")}
            >
                <AccordionSummary
                    expandIcon={
                        expanded === "panel1" ? (
                            <Remove sx={{ fontSize: "1.2rem" }} color={"action"} />
                        ) : (
                            <Add sx={{ fontSize: "1.2rem" }} color={"action"} />
                        )
                    }
                    sx={{ flexDirection: "row-reverse" }}
                >
                    <Typography ml={1} fontWeight={"bold"}>
                        USER RAW DATA
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <RawData jobDetails={jobDetails} cDadUnNestedDataValue={cDadUnNestedDataValue?.data} pageNo={pageNo} />
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === "panel2"}
                onChange={() => handleChange("panel2")}
            >
                <AccordionSummary
                    expandIcon={
                        expanded === "panel2" ? (
                            <Remove sx={{ fontSize: "1.2rem" }} color={"action"} />
                        ) : (
                            <Add sx={{ fontSize: "1.2rem" }} color={"action"} />
                        )
                    }
                    sx={{ flexDirection: "row-reverse" }}
                >
                    <Typography ml={1} fontWeight={"bold"}>
                        MAP VISUALIZATION
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                <MapVisualization jobDetails={jobDetails} expanded={expanded} />
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === "panel3"}
                onChange={() => handleChange("panel3")}
            >
                <AccordionSummary
                    expandIcon={
                        expanded === "panel3" ? (
                            <Remove sx={{ fontSize: "1.2rem" }} color={"action"} />
                        ) : (
                            <Add sx={{ fontSize: "1.2rem" }} color={"action"} />
                        )
                    }
                    sx={{ flexDirection: "row-reverse" }}
                >
                    <Typography ml={1} fontWeight={"bold"}>
                        SIGNAL DATA STATISTICS
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <SignalDataStatistics jobDetails={jobDetails} expanded={expanded} />
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === "panel4"}
                onChange={() => handleChange("panel4")}
            >
                <AccordionSummary
                    expandIcon={
                        expanded === "panel4" ? (
                            <Remove sx={{ fontSize: "1.2rem" }} color={"action"} />
                        ) : (
                            <Add sx={{ fontSize: "1.2rem" }} color={"action"} />
                        )
                    }
                    sx={{ flexDirection: "row-reverse" }}
                >
                    <Typography ml={1} fontWeight={"bold"} alignContent={'center'}>
                        DATA PREP FILL
                    </Typography>
                    <DataFillToolTip content={FillToolTipContent}/>
                </AccordionSummary>
                <AccordionDetails>
                    <DataPrep jobDetails={jobDetails} userInputData={signalListUnnested} />
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === "panel5"}
                onChange={() => handleChange("panel5")}
            >
                <AccordionSummary
                    expandIcon={
                        expanded === "panel5" ? (
                            <Remove sx={{ fontSize: "1.2rem" }} color={"action"} />
                        ) : (
                            <Add sx={{ fontSize: "1.2rem" }} color={"action"} />
                        )
                    }
                    sx={{ flexDirection: "row-reverse" }}
                >
                    <Typography ml={1} fontWeight={"bold"}>
                        DATA VISUALIZATION
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    {expanded === 'panel5' && <DataVisualization jobDetails={jobDetails} userInputData={signalListUnnested} vinListTimeSeries={vinListTimeSeries} subJobs={subJobs} requestTimeListTimeSeries={requestTimeListTimeSeries} headerJobId={headerJobId} />}
                </AccordionDetails>
            </Accordion>
            <Accordion
                expanded={expanded === "panel6"}
                onChange={() => handleChange("panel6")}
            >
                <AccordionSummary
                    expandIcon={
                        expanded === "panel6" ? (
                            <Remove sx={{ fontSize: "1.2rem" }} color={"action"} />
                        ) : (
                            <Add sx={{ fontSize: "1.2rem" }} color={"action"} />
                        )
                    }
                    sx={{ flexDirection: "row-reverse" }}
                >
                    <Typography ml={1} fontWeight={"bold"}>
                        SUMMARY STATISTICS
                    </Typography>
                </AccordionSummary>
                <AccordionDetails>
                {expanded === 'panel6' && <SummaryStatisticsDataVisualization jobDetails={jobDetails} subJobs={subJobs} userInputData={signalListUnnested} expanded={expanded} />}
                </AccordionDetails>
            </Accordion>
        </div>
    )

};

export default UserData;
